import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  select(event) {
    const name = event.currentTarget.dataset.tab
    this.tabTargets.forEach(tab => tab.classList.toggle('is-active', tab.dataset.tab === name))
    this.panelTargets.forEach(panel => panel.classList.toggle('hidden', panel.dataset.tab !== name))
  }
}
